import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.153 18.002h-5.96L6 16.325V8.002h1a1 1 0 0 0 .895-.553l2.712-5.425.393.015c.55 0 1 .45 1 1v2.962h-1a1 1 0 0 0 0 2h6.82l-1.667 10zM2 16.002v-8h2v8H2zm17.763-9.646A1 1 0 0 0 19 6.002h-5V3.04c0-1.654-1.345-3-2.96-3h-.002l-1-.038a.985.985 0 0 0-.932.553L6.382 6.002H1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h3.807l4.822 1.93c.117.046.243.07.37.07h7c.49 0 .906-.354.986-.835l2-12a.99.99 0 0 0-.223-.81z"
});

var SvgThumbsUpMajorMonotone = function SvgThumbsUpMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export { SvgThumbsUpMajorMonotone as S };
